export const promoCodesConst = {
    startPromoCode: 'RETURNMYCASH',
};
